// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"499":"28b50b4b","715":"52206752"}[chunkId] + ".chunk.js";
};